export default "__VITE_ASSET__DtUBp3_C__"